/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Social_Science24Inputs */

const en__field_enum_csjensblank_social_science24 = /** @type {(inputs: _Field_Enum_Csjensblank_Social_Science24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social Sciences`)
};

const de__field_enum_csjensblank_social_science24 = /** @type {(inputs: _Field_Enum_Csjensblank_Social_Science24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sozialwissenschaften`)
};

/**
* | output |
* | --- |
* | "Social Sciences" |
*
* @param {_Field_Enum_Csjensblank_Social_Science24Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_social_science24 = /** @type {((inputs?: _Field_Enum_Csjensblank_Social_Science24Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Social_Science24Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_social_science24(inputs)
	return de__field_enum_csjensblank_social_science24(inputs)
});
export { _field_enum_csjensblank_social_science24 as "_field_enum_CSJENSBLANK_SOCIAL_SCIENCE" }